import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-row align-items-center"
}
const _hoisted_2 = ["for"]
const _hoisted_3 = ["step", "id", "title", "value"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Mode FORM_GRID not yet implemented. ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Found illegal mode ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (this.isFlexMode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (this.label != null)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              class: _normalizeClass(_ctx.computedLabelCss),
              for: this.id != null ? this.id : _ctx.$id('numberInput')
            }, _toDisplayString(this.label), 11, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          type: "number",
          step: this.step,
          class: _normalizeClass(_ctx.computedInputCss),
          id: this.id != null ? this.id : _ctx.$id('numberInput'),
          title: this.title,
          value: _ctx.modelValue,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (this.$emit('update:modelValue', $event.target.value)))
        }, null, 42, _hoisted_3)
      ]))
    : (this.isFormGridMode)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_4
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _hoisted_5
        ], 64))
}